const IconBtn = ({children}) => {
  return (
    <>
      <div className="bg-secondary p-2 h-9 w-9 flex items-center justify-center border-tertiary border-2 rounded-full">
        {children}
      </div>
    </>
  );
};

export default IconBtn;
